/**
 * LLM 后台的 HTTP 出口 —— `api/llm/*` 的每个能力片都从这里取 http，各片不自己建。
 *
 * `basePath` 把 `/api/admin/visual-game/llm` 收在一处：各片写的是 `/providers`、`/models`、
 * `/calls` 这样的短路径，前缀改了只改这一行。
 *
 * 只有 `get` / `post` / `getText`（`createCallchainHttp` 就这三个）—— **写操作一律 POST**。
 * 每次调用必须带 `routeId`，它成为请求头 `x-callchain-route-id`，与后端路由注册处的
 * `@callchain.routeId` 标注一一对应。
 */

import { createCallchainHttp } from '../callchain-http.js'

/** @type {ReturnType<typeof createCallchainHttp>|null} */
let http = null

/**
 * 由 `main.js` 在装配期调一次。
 * @param {Omit<Parameters<typeof createCallchainHttp>[0], 'basePath'>} opts
 */
export function configureLlmAdminHttp(opts) {
  http = createCallchainHttp({ ...opts, basePath: '/api/admin/visual-game/llm' })
}

/** @returns {ReturnType<typeof createCallchainHttp>} */
export function llmHttp() {
  if (!http) throw new Error('configureLlmAdminHttp must be called before LLM admin API use')
  return http
}
